<template>
  <v-dialog @input="change" value="true" :content-class="'app-dialog ' + (isMobileOnly ? 'mobile' : '')" :max-width="dialogMaxWidth"
    @keydown="dialog_OnKeyDown" @click:outside="confirm=false">

    <v-card class="confirm-dialog">
      <v-form @submit.prevent="submit">
        <v-toolbar v-if="!!title" :color="color" class="app-dialog-header">
          <v-icon v-if="!!icon" class="mr-3">{{ icon }}</v-icon>
          <v-toolbar-title :class="$vuetify.breakpoint.xsOnly ? 'app-dialog-title-mobile' : ''" v-text="title" />
        </v-toolbar>
        <v-card-text class="app-dialog-body">
          <div class="long-uninterrupted-text" v-html="message"></div>
        </v-card-text>
        <v-card-actions class="app-dialog-footer flex-wrap">
          <v-btn v-if="showYesBtn" ref="yesBtn" @click="confirm=true" :color="buttonYesColor" type="submit" style="min-width: 100px"
            class="mt-2">
            {{ getLocale(buttonYesText) || getLocale('buttons.yes') }}
          </v-btn>
          <v-btn v-if="showNoBtn" ref="noBtn" @click="confirm=false" :color="buttonNoColor" type="submit" style="min-width: 100px"
            class="mt-2">
            {{ getLocale(buttonNoText) || getLocale('buttons.no') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

  </v-dialog>
</template>

<script>
import { isMobileOnly } from 'mobile-device-detect';

import { getLocale } from '@/helpers/locale-helper';
import { wait } from '@/helpers/ui-helper';

export default {
  props: {
    buttonYesText: {
      type: String,
      default: ''
    },
    buttonNoText: {
      type: String,
      default: ''
    },
    buttonYesColor: {
      type: String,
      default: 'primary'
    },
    buttonNoColor: {
      type: String,
      default: 'secondary'
    },
    color: {
      type: String,
      default: 'app-colors-background-light'
    },
    icon: {
      type: String,
      default: 'fa-info-circle'
    },
    message: {
      type: String,
      default: getLocale('confirmDialog.default.message')
    },
    onResult: {
      type: Function,
      default: () => {}
    },
    showYesBtn: {
      type: Boolean,
      default: true
    },
    showNoBtn: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: getLocale('confirmDialog.default.title')
    },
    width: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      confirm: false,
      dialogMaxWidth: '600px',
      value: false
    };
  },
  computed: {
    getLocale() {
      return getLocale;
    },
    isMobileOnly() {
      return isMobileOnly;
    }
  },
  created() {
    if (this.width) {
      this.dialogMaxWidth = this.width;
    }
  },
  mounted() {
    this.confirm = true;
    this.$nextTick(async() => {
      await wait(50);
      if (this.showYesBtn) {
        this.$refs.yesBtn.$el.focus();
      } else if (this.showNoBtn) {
        this.$refs.noBtn.$el.focus();
      }
    });
  },
  beforeDestroy() {
    this.onResult(this.confirm);
  },
  methods: {
    dialog_OnKeyDown(e) {
      if (e.key === 'ArrowRight') {
        this.$refs.noBtn.$el.focus();
      } else if (e.key === 'ArrowLeft') {
        this.$refs.yesBtn.$el.focus();
      } else if (e.key === 'Escape' || e.key === 'Esc') {
        this.confirm = false;
        this.submit();
      }
    },
    submit() {
      this.$emit('result', this.confirm);
      this.$destroy();
    },
    change() {
      this.$destroy();
    }
  }
};
</script>

<style lang="scss">
.confirm-dialog {
  .app-dialog-header {
    .v-icon {
      font-size: 1.5em;
    }
    .app-dialog-title-mobile {
      font-size: 1.15em;
    }
  }
  .app-dialog-body {
    max-height: 50vh;
    min-height: 75px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
.v-dialog.app-dialog .confirm-dialog .app-dialog-footer {
  padding-top: 0;
}
</style>
